import React from "react";
import { Typography } from "@material-ui/core";
import TapeVisualizer from "../../components/TapeVisualizer/TapeVisualizer";
import { isNullOrUndefined } from "../../utils/generalValidators";

const TuringCardContent = ({ path }) => {
  const tapeContent = path.currentTapeContent || "[]";

  let headPos = 0;
  if (!isNullOrUndefined(path.headPosition)) {
    headPos = path.headPosition;
  }

  return (
    <div style={{ padding: "5px 0", textAlign: "center", width: "100%" }}>
      <div
        style={{
          maxWidth: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          paddingBottom: "8px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TapeVisualizer tapeContent={tapeContent} headPosition={headPos} />
      </div>

      <Typography variant="body2" style={{ marginTop: 8 }}>
        {/*Lendo: <strong>{symbolRead}</strong>*/}
      </Typography>
    </div>
  );
};

export default TuringCardContent;
